import styled from 'styled-components';
import TermsAndConditions from '../../../register/termsAndConditions';

export const StyledTermsAndConditions = styled(TermsAndConditions)`
    margin: 0;
`;
